// extracted by mini-css-extract-plugin
export default {"main":"_75b0d8fa4a","tit":"_7fb244564e","maintitle":"_4fa6cb77b4","ylw":"c271970348","white":"c5bfe99b6b","mv_title":"_44f313b9d8","mv_nc":"de5ad95610","mv_in":"_23be1c36ed"};